import { render, staticRenderFns } from "./RawShipmentProduct.vue?vue&type=template&id=62a85221&"
import script from "./RawShipmentProduct.vue?vue&type=script&lang=js&"
export * from "./RawShipmentProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RawShipmentProduct.vue"
export default component.exports